import React from 'react';

const AccessDeniedModal = ({ onBlur }) => (
    <div style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(26, 28, 29, 0.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        backdropFilter: 'blur(4px)'
    }} onClick={onBlur}>
        <div style={{
            width: 400,
            background: '#fff',
            borderRadius: 12,
            padding: 32,
            textAlign: 'center',
            boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)'
        }} onClick={e => e.stopPropagation()}>
            <div style={{
                background: '#fff1f0',
                color: '#cf1322',
                width: 56,
                height: 56,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 16px'
            }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                </svg>
            </div>
            <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8, color: '#1a1c1d' }}>Access Denied</h2>
            <p style={{ fontSize: 13, color: '#6d7175', margin: '0 0 24px', lineHeight: '1.5' }}>
                You are currently logged in as a <strong>Member</strong>.
                <br />Please contact your Administrator for access to this feature.
            </p>
            <button
                onClick={onBlur}
                style={{
                    width: '100%',
                    padding: '10px',
                    borderRadius: 8,
                    border: 'none',
                    background: '#1976d2',
                    color: '#fff',
                    fontWeight: 600,
                    fontSize: 14,
                    cursor: 'pointer',
                    transition: 'background 0.2s'
                }}
                onMouseOver={e => e.currentTarget.style.background = '#1565c0'}
                onMouseOut={e => e.currentTarget.style.background = '#1976d2'}
            >
                Understood
            </button>
        </div>
    </div>
);

export default AccessDeniedModal;
